import { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "../../../index.css";
import { RiHotelLine } from "react-icons/ri";
import { IoArrowBackOutline, IoArrowForward } from "react-icons/io5";
import { getRestaurantsOrHotels } from "../../../api/user";
import { getAds } from "../../../api/common";
import { useQuery } from "@tanstack/react-query";
import { MdStar, MdStarHalf, MdStarOutline } from "react-icons/md";
import { useSettings } from "../../../context/SettingsContext";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../../hooks/useTranslation";
import UserPagination from "../../../components/common/UserPagination";
import { AdsSectionLoading, CardLoading } from "../../../helper/lorder";

const SponsoredHotelsAndRestaurants = ({show, prefer }) => {
    const { settings: hotelSettings } = useSettings();
    const showHotels = hotelSettings?.showHotels;
    const [selected, setSelected] = useState(prefer);
    const [userLocation, setUserLocation] = useState({
        latitude: null,
        longitude: null,
    });
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [page, setPage] = useState(1);
    const limit = 6;

    const {
        data: adsData,
        isLoading,
        isError,
        error,
    } = useQuery({
        queryKey: ["ads", userLocation, page, selected],
        queryFn: () =>
            getAds({
                showRestaurants: selected === "restaurants",
                page,
                latitude: userLocation.latitude,
                longitude: userLocation.longitude,
            }),
        keepPreviousData: true,
    });

    const data = adsData?.data?.advertisements;
    const settings = adsData?.data?.settings;
    const pagination = adsData?.data?.pagination

    if(data?.length === 0){
       return <TopHotelsAndRestaurants show={show} prefer={prefer} />
    }

    return (
        <>
            <div className="bg-[#FFF3EF] lg:py-[100px] md:py-[70px] py-[30px]">
                <div className="container">
                    <h2 className="text-center text-[#18181B] lg:text-[40px] md:text-[30px] text-[25px] font-semibold lg:leading-[50px] leading-9 lg:mb-[20px] mb-3">
                        
                        {t("home").discoverSection.ads}
                    </h2>
                    <div className="">
                        {show && (
                            <div className="flex items-center bg-[#D4EFD5] border border-[#4CAF50] rounded-full md:overflow-hidden md:w-fit w-full mx-auto">
                                {showHotels && (
                                    <button
                                        className={`basis-1/2 lg:px-[85px] lg:py-[19px] md:py-3 md:px-6 p-4 rounded-full lg:text-[20px] text-base transition-all lg:font-bold font-semibold  ${selected === "hotels"
                                            ? "bg-[#4CAF50] text-white lg:px-[85px] lg:py-[19px] md:py-3 md:px-6 p-4 "
                                            : "bg-transparent text-black"
                                            }`}
                                        onClick={() => setSelected("hotels")}
                                    >
                                        {t("home").discoverSection.tabs.hotels}
                                    </button>
                                )}

                                <button
                                    className={`basis-1/2 lg:px-[57px] lg:py-[19px]  md:py-3 md:px-6 p-4  rounded-full lg:text-[20px] text-base transition-all lg:font-bold font-semibold  ${selected === "restaurants"
                                        ? "bg-[#4CAF50] text-white lg:px-[57px] lg:py-[19px]  md:py-3 md:px-6 p-4"
                                        : "bg-transparent text-black"
                                        }`}
                                    onClick={() => setSelected("restaurants")}
                                >
                                    {t("home").discoverSection.tabs.restaurants}
                                </button>
                            </div>
                        )}



                        <div className=" mt-5">
                            {/* Sponsored Banner from settings */}
                            {settings?.bannerUrl && (
                                <div className="mb-8 relative rounded-lg overflow-hidden border border-gray-200">
                                    <img
                                        src={settings?.bannerUrl}
                                        alt="Sponsored Banner"
                                        className="w-full h-[250px] object-cover"
                                    />
                                    <div className={`absolute inset-0  flex flex-col justify-center items-center text-center px-4 ${(settings.bannerTitle || settings.bannerDescription) && "bg-black/60" }`}>
                                        {settings.bannerTitle && (
                                            <h3 className="text-white text-2xl font-bold mb-2">
                                                {settings.bannerTitle}
                                            </h3>
                                        )}
                                        {settings.bannerDescription && (
                                            <p className="text-white text-base max-w-[800px]">
                                                {settings.bannerDescription}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            )}


                            <div className="grid grid-cols-1 lg:grid-cols-3 sm:grid-cols-2 gap-[21px] items-center ">
                                {isLoading ? (
                                    <div className="flex justify-center py-12">
                                        <div className="w-12 h-12 border-4 border-green-500 border-t-transparent rounded-full animate-spin" />
                                    </div>
                                ) : isError ? (
                                    <p className="text-red-500 text-center mt-6">{error.message}</p>
                                ) : data?.length > 0 ? (
                                    data?.map((item) => {
                                        const isSponsored = true;
                                        return (
                                            <div
                                                key={item?._id}
                                                className="relative rounded-[10px] bg-white border border-[#D9D9D9] cursor-pointer"
                                                onClick={() => {
                                                    if (item?.hotelId) {
                                                        navigate(`/hoteldetail`, {
                                                            state: { hotelId: item?.hotelId?._id },
                                                        });
                                                    } else {
                                                        navigate(`/restaurantdetail`, {
                                                            state: { restaurantId: item?.restaurantId?._id },
                                                        });
                                                    }
                                                }}
                                            >
                                                {isSponsored && (
                                                    <span className="absolute top-2 left-2 bg-[#4CAF50] text-white text-xs px-3 py-1 rounded-full">
                                                        {t("home").discoverSection.sponsored}
                                                    </span>
                                                )}

                                                <div>
                                                    <img
                                                        src={
                                                            item?.hotelId
                                                                ? item?.hotelId?.images?.[0]
                                                                : item?.restaurantId?.images?.[0]
                                                        }
                                                        alt="hotel"
                                                        className="w-full h-[236px] object-cover rounded-t-[9px]"
                                                    />
                                                </div>
                                                <div className="pt-[14px] pb-[23px] pr-[17px] pl-[10px]">
                                                    <h2 className="text-lg font-semibold leading-[30px] mb-[5px] text-[#18181B]">
                                                        {item?.hotelId ? item?.hotelId?.name : item?.restaurantId?.name}
                                                    </h2>
                                                    <div className="flex items-center gap-[10px] justify-between flex-wrap">
                                                        <span className="text-base leading-[26px] text-[#18181B]">
                                                            {item?.hotelId
                                                                ? item?.hotelId?.address
                                                                : item?.restaurantId?.address}
                                                        </span>
                                                        <div className="flex items-center justify-end">
                                                            {Array(
                                                                Math.floor(
                                                                    item?.hotelId
                                                                        ? item?.hotelId?.rating
                                                                        : item?.restaurantId?.rating
                                                                )
                                                            )
                                                                .fill()
                                                                .map((_, index) => (
                                                                    <MdStar
                                                                        key={`full-${index}`}
                                                                        size={21}
                                                                        className="text-[#FF9D00]"
                                                                    />
                                                                ))}

                                                            {item?.hotelId
                                                                ? item?.hotelId?.rating
                                                                : item?.restaurantId?.rating % 1 !== 0 && (
                                                                    <MdStarHalf size={21} className="text-[#FF9D00]" />
                                                                )}

                                                            {Array(
                                                                5 -
                                                                Math.ceil(
                                                                    item?.hotelId
                                                                        ? item?.hotelId?.rating
                                                                        : item?.restaurantId?.rating
                                                                )
                                                            )
                                                                .fill()
                                                                .map((_, index) => (
                                                                    <MdStarOutline
                                                                        key={`empty-${index}`}
                                                                        size={21}
                                                                        className="text-[#FF9D00]"
                                                                    />
                                                                ))}
                                                        </div>
                                                    </div>
                                                    <div className="flex gap-[10px] items-center mt-[11px]">
                                                        <RiHotelLine size={24} className="text-[#7B7B7B]" />
                                                        <span className="text-[15px] leading-[30px] text-[#18181B]">
                                                            5 stars - 8.2/10 Very Good (1,008)
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className="flex justify-center items-center py-12">
                                        <p className="text-gray-500 text-lg">
                                            {t("hotelbookingfilter").noHotelsFound}
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>



                        {pagination?.totalPages > 1 && (
                            <UserPagination
                                currentPage={page}
                                setCurrentPage={setPage}
                                totalPages={pagination.totalPages}
                            />
                        )}

                    </div>
                </div>
            </div>
        </>
    );
};

export default SponsoredHotelsAndRestaurants;


const TopHotelsAndRestaurants = ({ show, prefer }) => {
  const { settings: hotelSettings } = useSettings();
  const showHotels = hotelSettings?.showHotels;
  const [selected, setSelected] = useState(prefer);
  const [userLocation, setUserLocation] = useState({
    latitude: null,
    longitude: null,
  });
  const navigate = useNavigate();
  const { t } = useTranslation();

  const isHotel = selected === "hotels";

  const {
    data: searchedData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["top-hotels-restaurants", selected, userLocation],
    queryFn: () =>
      getRestaurantsOrHotels({
        hotels: isHotel,
        latitude: userLocation.latitude,
        longitude: userLocation.longitude,
      }),
    keepPreviousData: true,
  });

  const data = searchedData?.data?.data;

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => {
          console.error("Location error:", error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  }, []);

  var settings2 = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    cssEase: "linear",

    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 3,
          infinite: true,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          infinite: true,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  const handleNavigate = (id) => {
    if (isHotel) {
      navigate(`/hoteldetail`, {
        state: { hotelId: id },
      });
    } else {
      navigate(`/restaurantdetail`, {
        state: { restaurantId: id },
      });
    }
  };

  return (
    <>
   
      <div className="bg-[#FFF3EF] lg:py-[100px] md:py-[70px] py-[30px]">
        <div className="container">
          <h2 className="text-center text-[#18181B] lg:text-[40px] md:text-[30px] text-[25px] font-semibold lg:leading-[50px] leading-9 lg:mb-[20px] mb-3">
            {/* {title ? title : `Discover Top ${showHotels ? "Hotels & " : ""}Restaurants`} */}

            {showHotels
              ? t("home").discoverSection.titleWithHotels
              : t("home").discoverSection.titleWithoutHotels}
          </h2>

          {show && (
            <p className="text-center text-lg leading-7 mb-[30px]">
              {t("home").discoverSection.subtitle}
            </p>
          )}

          {/* tab data */}
          <div className="">
            {/* Toggle Buttons */}

            {show && (
              <div className="flex items-center bg-[#D4EFD5] border border-[#4CAF50] rounded-full md:overflow-hidden md:w-fit w-full mx-auto">
                {showHotels && (
                  <button
                    className={`basis-1/2 lg:px-[85px] lg:py-[19px] md:py-3 md:px-6 p-4 rounded-full lg:text-[20px] text-base transition-all lg:font-bold font-semibold  ${
                      selected === "hotels"
                        ? "bg-[#4CAF50] text-white lg:px-[85px] lg:py-[19px] md:py-3 md:px-6 p-4 "
                        : "bg-transparent text-black"
                    }`}
                    onClick={() => setSelected("hotels")}
                  >
                    {t("home").discoverSection.tabs.hotels}
                  </button>
                )}

                <button
                  className={`basis-1/2 lg:px-[57px] lg:py-[19px]  md:py-3 md:px-6 p-4  rounded-full lg:text-[20px] text-base transition-all lg:font-bold font-semibold  ${
                    selected === "restaurants"
                      ? "bg-[#4CAF50] text-white lg:px-[57px] lg:py-[19px]  md:py-3 md:px-6 p-4"
                      : "bg-transparent text-black"
                  }`}
                  onClick={() => {
                    if (!showHotels) {
                      navigate("/restaurantordering");
                    } else {
                      setSelected("restaurants");
                    }
                  }}
                >
                  {t("home").discoverSection.tabs.restaurants}
                </button>
              </div>
            )}

{isLoading?<CardLoading/>:<div className="">
              <div className="pt-[37px] w-full filter-slider">
                <Slider {...settings2}>
                  {data?.map((item) => {
                    return (
                      <div
                        onClick={() => handleNavigate(item?._id)}
                        key={item?._id}
                        className="border border-[#D9D9D9] rounded-[10px] cursor-pointer"
                      >
                        <div>
                          <img
                            src={`${item?.images?.[0]}`}
                            alt="hotel"
                            className="w-full h-[284.65px] object-cover rounded-t-[9px]"
                          />
                        </div>
                        <div className="pt-[14px] pb-[23px] pr-[17px] pl-[10px]">
                          <h2 className="text-lg font-semibold leading-[30px] mb-[5px] text-[#18181B]">
                            {item?.name}
                          </h2>
                          <div className="flex items-center gap-[10px] justify-between flex-wrap">
                            <span className="text-base leading-[26px] text-[#18181B]">
                              {item?.address}
                            </span>
                            <div className="flex items-center gap-[2px]">
                              {Array(Math.floor(item?.rating))
                                .fill()
                                .map((_, index) => (
                                  <MdStar
                                    key={`full-${index}`}
                                    size={21}
                                    className="text-[#FF9D00]"
                                  />
                                ))}

                              {item?.rating % 1 !== 0 && (
                                <MdStarHalf
                                  size={21}
                                  className="text-[#FF9D00]"
                                />
                              )}

                              {Array(5 - Math.ceil(item?.rating))
                                .fill()
                                .map((_, index) => (
                                  <MdStarOutline
                                    key={`empty-${index}`}
                                    size={21}
                                    className="text-[#FF9D00]"
                                  />
                                ))}
                            </div>
                          </div>
                          <div className="flex gap-[10px] items-center mt-[11px]">
                            <RiHotelLine size={24} className="text-[#7B7B7B]" />
                            <span className="text-[15px] leading-[30px] text-[#18181B]">
                              5 stars - 8.2/10 Very Good (1,008)
                            </span>
                          </div>
                          <p className="text-[15px] text-[#4CAF50] semibold mt-[10px]">
                            {item?.distance
                              ? `${item?.distance} ${
                                  t("home").searchFilter.distanceText
                                }`
                              : null}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </Slider>
              </div>
            </div>}

            
          </div>
        </div>
      </div>
    </>
  );
};

